var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "In-kind_Icon",
    "data-name": "In-kind Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12758",
    "data-name": "Path 12758",
    d: "M14.384,13.974a1.872,1.872,0,0,0,2.647,0L21,10l.662-.662a3.743,3.743,0,0,0-.146-5.432,3.886,3.886,0,0,0-5.3.289l-.512.512L15.2,4.2A3.886,3.886,0,0,0,9.9,3.91a3.744,3.744,0,0,0-.146,5.432l.662.662Z",
    transform: "translate(0.562 0.996)",
    fill: "#d88dd3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12759",
    "data-name": "Path 12759",
    d: "M7.146,16.877,3.521,20.5A1.024,1.024,0,0,0,3.3,21.63L5.563,26.9a1.024,1.024,0,0,0,1.666.321l.609-.609a1.025,1.025,0,0,1,.724-.3h8.965a4.246,4.246,0,0,0,2.736-1l6.678-5.626a2.174,2.174,0,0,0,.809-1.869,2.015,2.015,0,0,0-1.129-1.608,2.177,2.177,0,0,0-2.031.124l-7.981,4.59a2.05,2.05,0,0,1-1.021.273H12.211a.578.578,0,1,1,0-1.157h2.143a.988.988,0,0,0,.988-.962l.015-.583a1.834,1.834,0,0,0-1.834-1.882H7.783a.9.9,0,0,0-.637.264Z",
    transform: "translate(0.779 0.477)",
    fill: "#d88dd3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkind);
export default __webpack_public_path__ + "static/media/inkind.372ddcbd2ca2e57fb3911639b351b373.svg";
export { ForwardRef as ReactComponent };